
import { isFoodInfoChanged } from "features/food/helper/foodHelper"
import { MealType, IngredientOptionType } from "model/food/types"
import { isEdamaFood } from "model/food/utils/typeGuards/foodTypeGuards"

export const checkIsIngredientsChanged = (
  ingredients: IngredientOptionType[],
  updatedIngredients: IngredientOptionType[],
) => {
  const hasIngredientChanged = ingredients.some((initIngredient) => {
    const ingredient = updatedIngredients.find(
      (ingredient) => ingredient.uuid === initIngredient.uuid,
    )

    if (!ingredient) {
      return true
    }

    if (isEdamaFood(ingredient)) {
      return isFoodInfoChanged(initIngredient, ingredient)
    } else {
      return ingredient.portion !== initIngredient.portion
    }
  })

  return hasIngredientChanged
}

const CheckIsMealChange = (
  originalMeal?: MealType,
  updatedMeal?: MealType,
): boolean => {
  const isMealChanged =
    originalMeal?.name !== updatedMeal?.name ||
    originalMeal?.portion !== updatedMeal?.portion ||
    originalMeal?.unit !== updatedMeal?.unit

  return isMealChanged
}

export default CheckIsMealChange
